const LAMBDA_URL =
  "https://aro3jn3404.execute-api.us-east-1.amazonaws.com/default/polygonFetcher";

const fmtDate = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;

/**
 * @param {string} buyCurrency 
 * @param {string} sellCurrency
 * @param {Object} [options]
 * @param {'year'|'month'|'day'|'hour'} [options.interval='hour']
 * @param {number} [options.lookbackDays=3]
 * @param {AbortSignal} [options.signal]
 * @returns {Promise<number>}
 */
export async function fetchLatestForexRate(
  buyCurrency,
  sellCurrency,
  { interval = "hour", lookbackDays = 3, signal } = {}
) {
  if (!buyCurrency || !sellCurrency) {
    throw new Error("buyCurrency/sellCurrency is required");
  }

  const pair = `${buyCurrency}${sellCurrency}`;

  const endDate = new Date();
  const startDate = new Date(endDate.getTime() - lookbackDays * 24 * 60 * 60 * 1000);

  const payload = {
    pair,
    start: fmtDate(startDate),
    end: fmtDate(endDate),
    interval,
  };

  const res = await fetch(LAMBDA_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`polygonFetcher error ${res.status}: ${text || "unknown"}`);
  }

  const jsonData = await res.json();
  const results = Array.isArray(jsonData?.results) ? jsonData.results : [];

  let series = results;
  if (interval === "hour") {
    const cutoff = Date.now() - 24 * 60 * 60 * 1000;
    series = results.filter((e) => e.t >= cutoff);
  }

  const last = series[series.length - 1] || results[results.length - 1];
  if (last && typeof last.c === "number") return last.c;

  throw new Error("No recent forex data available");
}
